module.exports = __webpack_public_path__ + "img/SKMJ_elec.75842822.jpg";